export const PORTAL_CLASS = "akv:relative akv:z-[1400]";

// Les variantes dialog/drawer sont EXCLUSIVES : jamais deux utilities de la
// même propriété empilées (l'ordre de la feuille Tailwind déciderait du
// gagnant — c'est ce qui décalait le drawer : p-6 battait p-0, w-640 battait
// w-520). DialogBase compose base + UNE seule variante.
const BACKDROP_BASE = "akv:fixed akv:inset-0 akv:z-[1400] akv:grid akv:overflow-auto akv:bg-[rgba(12,35,29,0.56)]";

export const BACKDROP_CLASS = [
  BACKDROP_BASE,
  "akv:p-6 akv:place-items-center",
  "akv:max-[640px]:place-items-end akv:max-[640px]:p-3",
].join(" ");

export const DRAWER_BACKDROP_CLASS = [
  BACKDROP_BASE,
  "akv:p-0 akv:place-items-stretch akv:place-content-end",
].join(" ");

const PANEL_BASE = [
  "akv:box-border akv:flex akv:flex-col akv:overflow-hidden",
  "akv:border-0",
  "akv:bg-ak-surface akv:shadow-ak-overlay akv:outline-none",
  "akv:focus-visible:outline-[3px] akv:focus-visible:outline-offset-2 akv:focus-visible:outline-ak-focus",
].join(" ");

export const PANEL_CLASS = [
  PANEL_BASE,
  "akv:max-h-[min(88vh,56.25rem)] akv:rounded-ak-surface",
  "akv:max-[640px]:w-full akv:max-[640px]:max-h-[94vh]",
].join(" ");

export const PANEL_SIZE_CLASSES = {
  small: "akv:w-[min(100%,30rem)]",
  medium: "akv:w-[min(100%,40rem)]",
  large: "akv:w-[min(100%,55rem)]",
  viewer: "akv:w-[min(100%,70rem)]",
};

export const DRAWER_CLASS = [
  PANEL_BASE,
  "akv:h-screen akv:max-h-screen akv:w-[min(92vw,32.5rem)]",
  "akv:rounded-l-ak-surface akv:rounded-r-none",
  "akv:max-[640px]:w-[min(96vw,32.5rem)]",
].join(" ");

// Plein écran : le panneau occupe toute la fenêtre (hauteur dynamique du
// viewport mobile), en-tête et corps resserrés. Variante EXCLUSIVE, comme le
// drawer : aucune utility partagée avec le dialogue centré.
export const FULLSCREEN_BACKDROP_CLASS = [
  BACKDROP_BASE,
  "akv:p-0 akv:place-items-stretch",
].join(" ");

export const FULLSCREEN_PANEL_CLASS = [
  PANEL_BASE,
  "akv:h-dvh akv:max-h-dvh akv:w-full akv:rounded-none",
].join(" ");

export const FULLSCREEN_HEADER_CLASS = [
  "akv:flex akv:flex-none akv:items-start akv:justify-between akv:gap-4 akv:px-5 akv:py-3",
  "akv:border-0 akv:border-b akv:border-solid akv:border-ak-border",
  "akv:max-[640px]:px-4 akv:max-[640px]:py-2",
].join(" ");

export const FULLSCREEN_BODY_CLASS = "akv:min-h-0 akv:flex-1 akv:overflow-auto akv:p-5 akv:max-[640px]:p-3";

export const HEADER_CLASS = [
  "akv:flex akv:flex-none akv:items-start akv:justify-between akv:gap-4 akv:p-6",
  "akv:border-0 akv:border-b akv:border-solid akv:border-ak-border",
  "akv:max-[640px]:p-4",
].join(" ");

export const BODY_CLASS = "akv:min-h-0 akv:overflow-auto akv:p-6 akv:max-[640px]:p-4";

export const FOOTER_CLASS = [
  "akv:flex akv:flex-none akv:flex-wrap akv:items-center akv:justify-end akv:gap-2",
  "akv:border-0 akv:border-t akv:border-solid akv:border-ak-border akv:bg-ak-subtle",
  "akv:px-6 akv:py-4 akv:max-[640px]:px-4 akv:max-[640px]:py-3",
].join(" ");

export const DIALOG_CONTENT_CLASS = "akv:flex akv:min-w-0 akv:flex-col akv:gap-4";

export const FEEDBACK_INTENT_CLASSES = {
  information: "akv:bg-[#eef5f2]",
  success: "akv:bg-ak-brand-soft",
  attention: "akv:bg-ak-highlight-soft",
  critical: "akv:bg-ak-critical-soft",
};

export const TOAST_INTENT_CLASSES = {
  information: "akv:bg-[#eef5f2]",
  success: "akv:bg-ak-brand-soft",
  attention: "akv:bg-ak-highlight-soft",
  critical: "akv:bg-ak-critical-soft",
};
